import config from '../config';

export const FETCH_PENDING_DRIVER_REG_COUNT_SUCCESS = 'FETCH_PENDING_DRIVER_REG_COUNT_SUCCESS';
export const UPDATE_PENDING_DRIVER_REG_COUNT = 'UPDATE_PENDING_DRIVER_REG_COUNT';

export function isNewRegisteredRow(row, vehicles = []) {
  if (!row?.is_registered) return false;
  if (row.onboarded_vehicle_id) return false;
  const rowReg = String(row.registration_no || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (rowReg && Array.isArray(vehicles) && vehicles.length > 0) {
    if (vehicles.some((v) => String(v.registration_no || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase() === rowReg)) {
      return false;
    }
  }
  return true;
}

function countsPayload(data, fallbackPending = 0) {
  const pendingCount = Number.isFinite(Number(data?.pending_count))
    ? Number(data.pending_count)
    : Number(fallbackPending) || 0;
  const registeredCount = Number.isFinite(Number(data?.registered_count))
    ? Number(data.registered_count)
    : 0;
  return { pendingCount, registeredCount };
}

export function fetchPendingDriverRegistrationCount() {
  return async (dispatch) => {
    try {
      const response = await fetch(`${config.opsApiBase}/driver-registration/pending-count`);
      const data = await response.json();
      const payload = countsPayload(data, data?.count);

      dispatch({
        type: FETCH_PENDING_DRIVER_REG_COUNT_SUCCESS,
        payload,
      });

      return payload.pendingCount + payload.registeredCount;
    } catch (error) {
      console.error('Error fetching pending driver registration count:', error);
      return 0;
    }
  };
}

export function updatePendingDriverRegistrationCount({ pendingCount = 0, registeredCount = 0 } = {}) {
  return {
    type: UPDATE_PENDING_DRIVER_REG_COUNT,
    payload: {
      pendingCount: Number(pendingCount) || 0,
      registeredCount: Number(registeredCount) || 0,
    },
  };
}
